<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
            Annuler une <strong>opération </strong>        </div>
         
          <b-row class="form-group">
            <b-col md="6">
              <label for="tarif">Numéro Transaction (*)</label>
              <input type="text" v-model="annulation.num_transaction" placeholder="Numéro de la transaction : TA7D6C6650"  @keyup="verif_info" class="form-control"/>
            </b-col>
            <b-col md="6">
              <label for="tarif">Code (*)</label>
              <input type="text" v-model="annulation.code_envoie" placeholder="Code de la transaction : 1497"  @keyup="verif_info" class="form-control"/>
            </b-col>  
          </b-row>
          <b-row class="form-group">
            <b-col md="6">
              <label for="solde">Type de pièces (*)</label>
               <b-form-select id="piece_libelle" v-model="annulation.piece_libelle" :plain="true" :options="options_typepiece">
              </b-form-select>
            </b-col>
            <b-col md="6">
              <label for="solde">N° Pièce (*)</label>
              <b-form-input type="text" v-model="annulation.num_piece_benef" placeholder="Numéro de la pièce de l'emmeteur"></b-form-input>
            </b-col>
          </b-row>
         
          <div slot="footer">
            <span v-if="verif"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
          <b-modal ref="myModalRef" hide-footer centered title="Confirmation du paiement de masse">
            <div class="d-block text-center">
              <p style>{{response.message}}</p>
              <h5>Voulez-vous continuer ?</h5>
            </div>
            <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_Paiement" style="max-width: 100%;">Annuler</b-btn>
            <b-btn class="mt-3 col-lg-6" variant="outline-success"  @click="post" style="max-width: 100%;">Valider</b-btn>
          </b-modal>
        </b-card> 

        <!-- <b-card v-if="displayLine">
          <div slot="header">
            Liste des <strong>lignes</strong> érronées 
          </div>
          <vue-good-table styleClass="vgt-table condensed bordered striped" :columns="columns" :rows="ligne_paiement" :fixed-header="false" :pagination-options="pagination" :search-options="search">
            <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                </span>
                <span v-else style="font-size: 0.875rem;">
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
          </vue-good-table>
        </b-card> -->
    </b-col>
  </b-row>
</template>

<script>
var FormData = require('form-data');
var fs = require('fs');
import { VueGoodTable } from 'vue-good-table';
import api from '../../../api/'
export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      displayLine :false,
      verif:false,
      options : [],
      options_typepiece : [],
      options_typeoperation : [],
      annulation:{
        num_transaction:'',
        code_envoie:'',
        piece_libelle:'',
        num_piece_benef:'',
      },
      atm:[],
      typepiece:[],
      typeoperation:[],
      files: [],
      ligne_paiement:[],
      serverParams: {
          page:1,
          current_page: 1,
          paginate: 10
        }
    }
  },
  methods:{
    get_all_linesError(){
        this.$store.dispatch('mandate/get_all_mandates').then(()=>{
          return this.rows =  store.getters['mandate/rows'];
        })
    },
     goBack() {
        this.$router.go(-1)
      },
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    verif_info(){
        if (this.annulation.num_transaction.length==0 || this.annulation.code_envoie.length==0){
        this.verif = false
      }else{
        this.verif = true
      }
    },
    async get_all_typepieces(){
          //this.typepiece = store.getters['typepiece/rows'];
          await this.$store.dispatch('typepiece/get_all_typepieces',this.serverParams).then(()=>{
            return this.typepiece =  store.getters['typepiece/rows'];
          })
          this.typepiece.forEach((element)=>{
              this.options_typepiece.push({
                value:element.libelle,
                text:element.libelle
              })
          })
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    previewFiles() {
      this.files = this.$refs.myFiles.files
      this.paiement_file = this.files[0]
      console.log('mes fichiers ',this.files[0])
    },
    async post(){
        let annulation_info = {
          num_transaction:this.annulation.num_transaction,
          code_envoi:this.annulation.code_envoie,
          piece_libelle:this.annulation.piece_libelle,
          num_piece_benef:this.annulation.num_piece_benef
        }
        //console.log("paiement info ",paiement_info)
        this.response = await this.$store.dispatch('mandate/validateAnnulation',annulation_info)
        this.showAlert()
        if(this.response){
          //this.hideModal() 
        }
        if(this.response.success== true){
          this.reset()
          let solde = await api.atm.get_auth_guichets(token)
          localStorage.setItem('solde', solde.data.data.solde)
          window.open(this.response.data.content, "_blank")
          setTimeout(function(){ location.reload(); }, 3000);
        }
    },
    async cancel_Paiement(){
        let paiement_info = {
          id_paiement:this.response.data[0].id_paiement,
          code_paiement:this.response.data[0].code_paiement
          
        }
        this.response = await this.$store.dispatch('mandate/cancel_paiement',paiement_info)
        this.showAlert()
        if(this.response){
          this.hideModal() 
        }
        //this.reset()

    },
    async confirm(){
        let annulation_info = {
          num_transaction:this.annulation.num_transaction,
          code_envoi:this.annulation.code_envoie,
          piece_libelle:this.annulation.piece_libelle,
          num_piece_benef:this.annulation.num_piece_benef
        }
        this.response = await this.$store.dispatch('mandate/info_paiement',annulation_info)
        this.showAlert()
        if(this.response.success == true){
          this.displayLine = false
          this.$refs.myModalRef.show()
        }

    },
    hideModal () {
      this.$refs.myModalRef.hide()
    },
    async postmontant(){
        let data = {
          montant_transfere:this.mandats.montant_transfere
        }
        this.response = await this.$store.dispatch('mandate/montantttc',data)
        this.mandats.montant_ttc = this.$store.getters['mandate/getMontant']
        this.showAlert()
        this.verif = false
        //console.log(this.$store.getters['mandate/getMontant'])
    },
    reset(){
        this.annulation.num_transaction= "",
        this.annulation.num_piece_benef= "",
        this.annulation.piece_libelle= "",
        this.annulation.code_envoie= ""
        // this.paiement.telephone= "",
        // this.paiement.paiement_file= ""
    }
  },
  mounted(){
      this.get_all_typepieces()
  }
}
</script>
